if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', function(event) {
        if (event.target.tagName === 'SELECT') {
          var form = event.target.closest('form');
          if (form) form.submit();
        }
      });
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() { super(); }
  }
  customElements.define('details-disclosure', DetailsDisclosure);
}